import React from "react"

export default class AlternateIdButton extends React.Component{

  constructor (props) {
    super(props);
  }

	render() {
    var alternate_id

    this.props.data.map((obj) => {
      if (this.props.checkedCheckboxIds.includes(obj.id)) {
        alternate_id = obj[this.props.table_action.alternate_column]
      }
    })

	  if (this.props.table_action) {
	    var href = this.props.table_action.path.replace(/\$id/g, alternate_id);
	    if (this.props.action_params) {
	      if (href.indexOf('?') == -1) {
	        href = href + '?' + this.props.action_params;
	      } else {
	        href = href + '&' + this.props.action_params;
	      }
      }

	    return <a key={this.props.table_action.label} ref={this.props.table_action.label + '_btn'} className={"btn btn-dark " + (this.props.table_action.no_modal_iframe ? '' : ' modal-iframe ') + this.props.table_action.classes}
              data-fullscreen={typeof this.props.table_action.fullscreen !== 'undefined' ? this.props.table_action.fullscreen : true} href={href} disabled={this.isActionDisabled(this.props.table_action)} 
              style={this.props.table_action.classes && this.props.table_action.classes.includes("insert-images") ? {visibility: "hidden", position: "absolute"} : {}}>{this.toTitleCase(I18n.t(this.props.table_action.label))}</a>;
	  }
	}

  isActionDisabled(table_action) {
    if (this.disableButtons()) {
      return true
    }

    if (this.props.checkboxesChecked.length >= 1 && this.props.table_action.enabled == 'multiple') {
      return false;
    } else if (this.props.checkboxesChecked.length == 1 && this.props.table_action.enabled == 'single') {
      return false;
    } else if (this.props.table_action.enabled == true) {
      return false;
    } else {
      return true;
    }
  }

  toTitleCase(str) {
    return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
  }

  disableButtons() {
    if (this.props.disabled_ids && this.props.disabled_ids.includes(this.props.checkboxesChecked[0])) {
      return true
    }
    return false
  }
};